export default __webpack_public_path__ + "static/media/familytime.346d804a.jpg";